"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAppConfig = void 0;
var yup = require("yup");
var ProductKindLimit_1 = require("./ProductKindLimit");
var appConfigSchema = yup.object().shape({
    minVersion: yup
        .object()
        .shape({
        ios: yup.string().required(),
        android: yup.string().required(),
    })
        .required(),
    nextVersion: yup
        .object()
        .shape({
        ios: yup.string().required(),
        android: yup.string().required(),
    })
        .required(),
    appStoreVersion: yup
        .object()
        .shape({
        ios: yup.string().required(),
        android: yup.string().required(),
    })
        .required(),
    enabledPaymentMethodTypes: yup
        .object()
        .shape({
        ios: yup.array().of(yup.string()).required(),
        android: yup.array().of(yup.string()).required(),
    })
        .required(),
    featuresFlags: yup.array().of(yup.object()).optional(),
    disabledRestrictions: yup
        .object()
        .shape({
        ios: yup.array().of(yup.string()).optional(),
        android: yup.array().of(yup.string()).optional(),
    })
        .optional(),
    productKindLimits: yup.array().of(ProductKindLimit_1.productKindLimitSchema).required(),
    sentryTracesSampleRate: yup.number().optional(),
    riderTipsReviewThreshold: yup.number().optional(),
});
function isAppConfig(obj) {
    return appConfigSchema.isValidSync(obj);
}
exports.isAppConfig = isAppConfig;
